<template>
  <div v-show="loadingCompleted">
    <div class="d-flex align-items-end font-size-md text-mcf-color">
      <div class="mb-n1 p-1 image-panel image-panel-0 bg-transparent">
        <img class="w-100" :src="iconSource" alt="">
      </div>
      <div>
        <span class="h4 font-weight-normal text-customize">{{ totalPoint | currency }}</span>
        <span class="mx-1">{{ pointUnit }}</span>
      </div>
      <div class="text-right flex-grow-1" v-if="nextLevel">
        {{ upgradeHint }}
      </div>
    </div>
    <b-progress :max="nextLevel ? progress.next : progress.current" class="w-100 rounded-pill my-2" height="4px">
      <b-progress-bar :value="progress.current" variant="" class="bg-customize"></b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  data() {
    return {
      // 資料是否完成載入
      loadingCompleted: false,
      // 會籍icon來源
      iconSource: '',
      // 會員積點總和
      totalPoint: 0,
      // 積點單位
      pointUnit: '',
      // 可升級會籍等級
      nextLevel: '',
      // 升級提示文案
      upgradeHintWording: '',
      // 升級進度
      progress: {
        // 目前點數
        current: 0,
        // 升級點數
        next: 1,
      },
    };
  },
  computed: {
    // 升級提示
    upgradeHint() {
      const vm = this;
      const difference = vm.progress.next - vm.progress.current;
      return vm.upgradeHintWording
        .replace(/{UpgradeAmount}/igm, difference)
        .replace(/{UpgradeType}/igm, vm.nextLevel);
    },
  },
  watch: {
    $route() {
      const vm = this;
      // 切換route時，更新會員積點
      vm.$store.dispatch('getMemberBonus').then((memberBonus) => {
        vm.totalPoint = memberBonus.pointSum;
      });
    },
  },
  created() {
    const vm = this;
    // 取得頁面設定資料
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage');
    getPageSetting.then((setting) => {
      vm.upgradeHintWording = pageSettingGetter.getFunctionWording(setting, 'PromoteUpgradeWording');
      vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
    });
    // 取得會籍資料
    const getMemberType = vm.$store.dispatch('getMemberType');
    getMemberType.then((memberType) => {
      vm.iconSource = memberType.iconPic;
      vm.nextLevel = memberType.nextLevel;
      vm.progress = {
        current: memberType.currentAmount,
        next: memberType.upgradeAmount,
      };
    });
    // 取得會員積點
    const getMemberBonus = vm.$store.dispatch('getMemberBonus');
    getMemberBonus.then((memberBonus) => {
      vm.totalPoint = memberBonus.pointSum;
    });
    Promise.all([getPageSetting, getMemberType, getMemberBonus])
      .then(() => { vm.loadingCompleted = true; });
  },
};
</script>
